import { useQuery } from '@tanstack/react-query';
import { getEmailSummary } from '../lib/emailApi';

/**
 * Load the Daily Email Summary (read-only Gmail + AI processing) for a
 * user/date (CLE-233). Cached for 5 minutes, matching the daily summary; the
 * backend additionally serves its own processed-email cache so refreshes are
 * cheap. Only the configured owner mailbox returns emails.
 */
export function useEmailSummary(userId: string | undefined, date: string | undefined) {
  return useQuery({
    queryKey: ['email-summary', userId, date],
    queryFn: () => getEmailSummary(userId!, date),
    enabled: Boolean(userId),
    staleTime: 5 * 60 * 1000,
  });
}
